export enum ColorScheme {
  System = 'system',
  Light = 'light',
  Dark = 'dark',
}
